import isPlainObject from "is-plain-object";

export default values => {
  let formData = new FormData();

  for (var key in values) {
    const value = values[key];
    formData.append(
      key,
      value instanceof Array || isPlainObject(value)
        ? JSON.stringify(value)
        : value
    );
  }

  return formData;
};



// WEBPACK FOOTER //
// ./src/core/utils/toFormData.js